import { Alert, Text } from "@mantine/core";
import { semanticColor } from "@how/design-system";
import { formatPhone } from "./format-phone";
import { useSmsSender } from "./sms-sender-queries";

/**
 * Pilot texting (ADR 0072): while DCX Logic has it on for the church, every Communications page says so, plainly,
 * so nobody expects a text to reach the whole church or to come from the church's own name. Nothing shows otherwise.
 */
export function PilotTextingBanner() {
  const sender = useSmsSender();
  const data = sender.data;
  if (data?.pilot !== true) return null;
  const name = data.senderName === "" ? "DCX Logic's pilot sender" : data.senderName;
  return (
    <Alert
      color={semanticColor("info")}
      variant="light"
      mb="md"
      role="status"
      data-testid="pilot-texting-banner"
    >
      <Text size="sm" fw={600}>
        {`Pilot texting: texts go out from ${name} to opted-in pilot testers only.`}
      </Text>
      <Text size="sm" c="dimmed">
        {`Every text ends "${name}: Reply STOP to opt out"${
          data.from === null ? "" : ` and comes from ${formatPhone(data.from)}`
        }. Anyone who isn't a pilot tester is skipped, and the campaign's report says how many.`}
      </Text>
    </Alert>
  );
}
